import React, { Component } from 'react'

import { connect, batch } from 'react-redux';
import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux';
import { withStyles, Typography, TextField } from '@material-ui/core';


import { withRouter } from 'react-router';
import { getLocationPathName } from '../../selectors/util.selector';
import { DatePicker, DateTimePicker } from "material-ui-pickers";
import moment, { Moment } from 'moment'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import { isSetPullDateDialogDialogOpen } from '../../selectors/phaseplan.selector';
import Dialog from '@material-ui/core/Dialog'
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button';
import { dialogActions } from '../../actions/dialog.actions';
import { ThunkDispatch } from 'redux-thunk';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { lookaheadActions } from '../../actions/lookahead.actions';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import { Variance, VarianceToEnglish } from '../../utils/Variance';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PullOrPush } from '../../utils/PullOrPush';
import { phasePlanActions } from '../../actions/phaseplan.actions';
import { isMRPCreateDialogOpen, rowCountRow } from '../../selectors/dialog.selector';
import { CirclePicker } from 'react-color';
import { getOldRowCountData } from '../../selectors/lookahead.selector';
import WeekdayPicker from '../WeekdayPicker';

interface Props {
    isMRPCreateDialogOpen: boolean;
    closeDialogValue: () => void;
    changeGroupSetting: (row: number, name: string, color: string) => void;
    classes: ClassNameMap,
    createMRP: (name:string) => void

}



type State = {
    name: string
}


class _CreateMRPDialog extends Component<Props, State> {

    state = {
        name: ''
    }


    async closeDialog() {
        const { closeDialogValue } = this.props
        closeDialogValue()
    }

    onConfirm = () => {
        const { closeDialogValue, createMRP } = this.props
        const { name } = this.state

        batch(() => {
            createMRP(name)
            closeDialogValue()
        })
    }



    onNameChange = async (event: any) => {
        

        this.setState({
            name: event.target.value
        });
    }

    onEnter = () => {
        
    }

    
    

    render() {
        const { classes, isMRPCreateDialogOpen } = this.props;
        const { name } = this.state
        return (
            <Dialog
                onEnter={this.onEnter}
                maxWidth='xs'
                fullWidth={true}
                open={!!isMRPCreateDialogOpen}
                
            >
                <DialogContent>
                    <div style={{backgroundColor: '#4286dd'}} className={classes.DialogFormTitle}>
                        <p className={classes.DialogFormTitleText}>
                            Create Plan
                        </p>
                    </div>
                    <div className={classes.DialogFormContent} >
                        <div className={classes.DialogFormField}>

                            <TextField
                                variant="filled"
                                label="Name"
                                disabled={false}
                                required={true}
                                value={!!name ? name : ""}
                                onChange={this.onNameChange}
                                fullWidth={true}
                            />
                        </div>
                        <div >
                            <p className={classes.DialogFormLabel}>Offdays</p>

                            <WeekdayPicker />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeDialog.bind(this)} color="secondary"> Cancel </Button>
                    <Button onClick={this.onConfirm}  color="primary"> Confirm </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const mapStateToProps = (state:any) => ({
    isMRPCreateDialogOpen: isMRPCreateDialogOpen(state)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        closeDialogValue: () => dispatch(dialogActions.closedMRPDialog()),
        createMRP: (name:string) => dispatch(lookaheadActions.createMRP(name))
    }
};


export default compose<React.ComponentClass>(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles, { withTheme: true }),
)(_CreateMRPDialog)


// WEBPACK FOOTER //
// ./src/components/Dialogs/MRPDialogContainer.tsx